import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { AccountService } from './account.service';
import { environment } from '../../environments/environment';
import { Report, ChartReport, ReportType, ReportRole, TabularReport, Filter } from '../models/Report';
import { DataTableResponse } from '../models/DatatableResponse';
import {saveAs} from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  public headers = new HttpHeaders();
  private reportUrl = environment.baseUrl + '/Report';
  private reportRoleUrl = environment.baseUrl + '/ReportRole';
  private reportTypeUrl = environment.baseUrl + '/ReportType';
  public filters : Array<Filter>;

  constructor(private http: HttpClient, private accountService: AccountService) {

  }

  getDataTableOptions(reportID, columns, filters) {
    const that = this;
    this.filters = filters;
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
    headers = headers.set('Authorization', 'Bearer '+ this.accountService.getTokenData());
    
    let cols = [];
    columns.forEach(elt => {
      cols.push({'data' : elt.fieldName, 
                'title': elt.title,
                'visible': elt.isVisible, 
                'orderable' : elt.isSortable,
                'render' : function(data, type, row, meta){
                  if(elt.dataType == 'Date'){
                    return new Date(data).toLocaleDateString('en-US', {year : 'numeric', month: 'short', day: 'numeric'});
                  }
                  if(data === ""){
                    return "-";
                  }
                  if(elt.fieldName == 'application_number'){
                    let id = data.split('/')[0].replace(/\b0+/g, '');
                    return "<a title=\"Click to view more\" href=\"/applications/list/"+ id +"\">"+data+"</a>";
                  }
                  return data;
                }
              })
    });

    let options = {
      pagingType: 'full_numbers',
      pageLength: 10,
      serverSide: true,
      processing: true,
      searching: false,
      dom: "lBrtip",
      buttons:[
        {
          text: 'PDF',
          action: function(e, dt, node, config){
            that.getReport(reportID).subscribe(
              resp1 => {
                that.exportPdf(reportID).subscribe(
                  resp => {
                    let blob = new Blob([resp], {type : 'pdf'});
                    saveAs(blob, resp1.name+'.pdf'); 
                  });
              });
          }
        },
        {
          text: 'Excel',
          action: function(e, dt, node, config){
            that.getReport(reportID).subscribe(
              resp1 => {
                that.exportExcel(reportID).subscribe(
                  resp => {
                    let blob = new Blob([resp], {type : 'xlsx'});
                    saveAs(blob, resp1.name+'.xlsx'); 
                  });
              });
          }
        }
      ],
      language : {
        processing : '<div class="sk-spinner sk-spinner-three-bounce"> <div class="sk-bounce1"></div> <div class="sk-bounce2"></div> <div class="sk-bounce3"></div> </div>'
      },
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters['filters'] = this.filters;
        that.http.post<DataTableResponse>(this.reportUrl + '/Tabular/' + reportID, $.param(dataTablesParameters), {headers: headers})
          .subscribe(
            resp => {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: resp.data
              });
            },
            error => {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
          );
      },
      columns: cols
    }

    return options;
  }

  getReportListByUser(userID: number){
    return this.http.get<ChartReport[]>(this.reportUrl + '/Chart/ByUser/' + userID);
  }

  getChartReport(reportID : number){
    return this.http.get<ChartReport>(this.reportUrl + '/Chart/'+ reportID);
  }

  getTabularReport(reportID: number){
    return this.http.get<TabularReport>(this.reportUrl + '/Tabular/' + reportID);
  }

  getAllReports(){
    return this.http.get<Report[]>(this.reportUrl);
  }

  getReport(reportID : number){
    return this.http.get<Report>(this.reportUrl + '/'+ reportID);
  }

  getReportByRole(roleID: number){
    return this.http.get<ReportRole[]>(this.reportRoleUrl + '/ReportByRole/' + roleID)
  }

  getReportsByReportType(reportTypeID: number){
    return this.http.get<Report[]>(this.reportUrl + '/ByReportType/' + reportTypeID);
  }

  getTabularReportListByUser(userID: number){
    return this.http.get<TabularReport[]>(this.reportUrl + '/Tabular/ByUser/' + userID);
  }

  addReportRole(reportRole){
    return this.http.post<any>(this.reportRoleUrl ,reportRole);
  }

  unlinkReportRole(id) {
    return this.http.delete<any>(this.reportRoleUrl + '/' + id);
  }

  getReportTypes(){
    return this.http.get<ReportType[]>(this.reportTypeUrl);
  }

  updateReport(report : Report){
    return this.http.put<any>(this.reportUrl , report);
  }

  createReport(report: Report){
    return this.http.post<any>(this.reportUrl , report);
  }

  exportExcel(id){
    return this.http.post(this.reportUrl + '/Tabular/Export/Excel/' + id, this.filters, { responseType: 'blob' });
  }
  exportPdf(id){
    return this.http.post(this.reportUrl + '/Tabular/Export/Pdf/' + id, this.filters, { responseType: 'blob' });
  }
}
